"use client";
import { jsx as e } from "react/jsx-runtime";
import { Link as I, sharedHandler as f } from "@ingeniorforeningen/figurine-core";
import { forwardRef as h } from "react";
import l from "./variants/ListItemWithImage.js";
import c from "./variants/ListItemWithoutImage.js";
const r = h((i, a) => {
  const { variant: o = "withoutImage", className: s, link: m, ...t } = i, n = t, p = t;
  return /* @__PURE__ */ e(I, { ref: a, href: m.href, target: m.target, className: s, ...t, children: o === "withImage" ? /* @__PURE__ */ e(l, { ...n }) : /* @__PURE__ */ e(c, { ...p }) });
});
r.displayName = "ListItem";
const d = f(r);
d.displayName = r.displayName;
export {
  r as _ListItem,
  d as default
};
